import { render, staticRenderFns } from "./bdmItemAdd.vue?vue&type=template&id=5ed97fea&scoped=true"
import script from "./bdmItemAdd.vue?vue&type=script&lang=js"
export * from "./bdmItemAdd.vue?vue&type=script&lang=js"
import style0 from "./bdmItemAdd.vue?vue&type=style&index=0&id=5ed97fea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed97fea",
  null
  
)

export default component.exports